import qs from 'qs';
import client from './client';

const partnerUrl = '/api/v1/master/partner';
const productUrl = '/api/v1/master/product';

//파트너 리스트 가져오기(추후에 검색어 기능 달기)
export const getPartners = (searchData) => {
  const queryString = qs.stringify(searchData);
  return client.get(`${partnerUrl}/list?${queryString}`);
};

//파트너명 가져오기
export const getPartnerNames = () => {
  return client.get(`${partnerUrl}/list/name`);
};

//파트너 추가
export const addPartner = (dataToSubmit) => {
  return client.post(`${partnerUrl}/info`, dataToSubmit);
};

//파트너 정보
export const getPartner = (id) => client.get(`${partnerUrl}/info/${id}`);

export const editPartner = (dataToSubmit) => {
  return client.put(
    `${partnerUrl}/info/${dataToSubmit.partnerUuid}`,
    dataToSubmit,
  );
};

//파트너 삭제
export const removePartner = (id) => client.delete(`${partnerUrl}/info/${id}`);

//파트너 담당자 가져오기
export const getPartnerEmp = (id) => {
  return client.get(`${partnerUrl}/list/${id}/employee`);
};

//파트너 담당자 등록
export const addPartnerEmp = (id, dataToSubmit) => {
  return client.post(`${partnerUrl}/info/${id}`, dataToSubmit);
};

//파트너 담당자 수정
export const editPartnerEmp = (dataToSubmit) => {
  return client.put(
    `${partnerUrl}/info/${dataToSubmit.partnerUuid}/employee/${dataToSubmit.employeeUuid}`,
    dataToSubmit,
  );
};

//파트너 담당자 삭제
export const removePartnerEmp = (partnerUuid, empId) => {
  return client.delete(`${partnerUrl}/info/${partnerUuid}/employee/${empId}`);
};

//파트너 파일 가져오기
export const getPartnerFiles = ({ fileTyp, fileAttrVal1 }) => {
  const queryString = qs.stringify({
    fileTyp,
    fileAttrVal1,
  });
  return client.get(`/api/v1/file/list?${queryString}`);
};

//제품가격정보리스트
export const getProductPriceByPartner = (searchData) => {
  const queryString = qs.stringify(searchData);
  return client.get(`${productUrl}/price?${queryString}`);
};

//파트너 엑셀 업로드
export const uploadExl = (formData) => {
  return client.post(`${partnerUrl}/uploadExl`, formData, {
    header: { 'Content-type': 'multipart/form-data' },
  });
};
